module.exports = __webpack_public_path__ + "static/img/shinpaku.584428e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3kfan/shinpaku.png
// module id = j9r8
// module chunks = 0